import { createApiRef } from '@backstage/core-plugin-api';

/** @public */
export const FileStorePluginApiRef = createApiRef<FileStorePluginApi>({
  id: 'plugin.file-store-plugin.service',
});

/** @public */
export interface FileStorePluginApi {
  getLatestLog(applianceId: string, date: string): Promise<FileResponse>;
  getAllLogs(applianceId: string, date: string): Promise<FileResponse[]>;
  createLogArchive(
    applianceId: string,
    date: string,
    fileNames: string[],
  ): Promise<FileResponse>;
  getLatestImage(applianceId: string, feature: string): Promise<FileResponse>;
  getImageByName(
    applianceId: string,
    imageName: string,
    feature: string,
  ): Promise<FileResponse>;
  getLatestCapability(): Promise<FileResponse>;
  getAllCapabilities(): Promise<FileResponse[]>;
}

/** @public */
export interface FileResponse {
  fileURL: string;
  cDate: string;
  name: string;
}
